import RouteLoader from './route-loader';

export default RouteLoader;
